import { useEffect, useRef } from 'react';
import ChatMessage from 'components/ChatMessage';
import './ChatContainer.scss';

interface ChatContainerProps {
  messages: ChatMessageProps[];
}

function ChatContainer({ messages }: ChatContainerProps) {
  const messagesEndRef = useRef<HTMLDivElement | null>(null);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div className="chat-container">
      <div className="messages">
        {messages.map((message, index) => (
          <ChatMessage
            key={index}
            role={message.role}
            content={message.content}
            selection={message.selection}
          />
        ))} 
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
}

export default ChatContainer;
